import {
  GeneralSearchFeatureType,
  GeneralSearchMetaByKeywordQuery,
  GeneralSearchSnippetType,
} from '@/types/bff/gql-schema';
import { EGeneralSearchFeatureType, EGeneralSearchSnippetType, GeneralSearchMetaByKeywordVo } from '@/types/search';
import { useGeneralSearchMetaByKeywordQuery } from './search.gql.impl';

interface Props {
  keyword: string;
}

const parseGeneralSearchSnippetType = (type?: GeneralSearchSnippetType | null) => {
  switch (type) {
    case GeneralSearchSnippetType.DeliveryGuide:
      return EGeneralSearchSnippetType.DeliveryGuide;
    case GeneralSearchSnippetType.FaceToFaceDiagnosis:
      return EGeneralSearchSnippetType.FaceToFaceDiagnosis;
    case GeneralSearchSnippetType.FaceToFacePrescription:
      return EGeneralSearchSnippetType.FaceToFacePrescription;
    case GeneralSearchSnippetType.NonFaceToFaceDiagnosis:
      return EGeneralSearchSnippetType.NonFaceToFaceDiagnosis;
    case GeneralSearchSnippetType.NonFaceToFacePrescription:
      return EGeneralSearchSnippetType.NonFaceToFacePrescription;
    default:
      return undefined;
  }
};

const parseGeneralSearchFeatureType = (type: GeneralSearchFeatureType) => {
  switch (type) {
    case GeneralSearchFeatureType.DietInjection:
      return EGeneralSearchFeatureType.DietInjection;
    case GeneralSearchFeatureType.EmergencyContraceptive:
      return EGeneralSearchFeatureType.EmergencyContraceptive;
    case GeneralSearchFeatureType.FindPharmacy:
      return EGeneralSearchFeatureType.FindPharmacy;
  }
};

const parseGeneralSearchMetaByKeyword =
  (keyword: string) =>
  (data: GeneralSearchMetaByKeywordQuery): GeneralSearchMetaByKeywordVo => {
    return {
      keyword,
      snippet: parseGeneralSearchSnippetType(data.generalSearchMetaByKeyword?.snippet),
      features: data.generalSearchMetaByKeyword?.features
        ? data.generalSearchMetaByKeyword.features.map((type) => parseGeneralSearchFeatureType(type))
        : undefined,
    };
  };

const useGeneralSearchMetaByKeyword = ({ keyword }: Props) => {
  const { data } = useGeneralSearchMetaByKeywordQuery(
    {
      keyword,
    },
    {
      enabled: keyword.length > 1,
      select: parseGeneralSearchMetaByKeyword(keyword),
    }
  );

  return { generalSearchMetaByKeyword: data };
};

export default useGeneralSearchMetaByKeyword;
